import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { gatewayPhone } from "../../../../gateways/gatewayPhone";

export enum CompanyNumberSource {
  PORTING = 'PORTING',
  BUYING = 'BUYING',
}

export enum CompanyNumberStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
  RELEASED = 'RELEASED',
}


export type CompanyNumberItem = {
  uid: string;
  phoneNumber: string;
  name: string | null;
  source: CompanyNumberSource;
  status: CompanyNumberStatus;
};

export type CompanyNumbersByCompany = {
  companyId: string;
  phoneNumbers: CompanyNumberItem[];
};

export const useCompanyNumbersMultiQuery = (companiesIds?: string[]) => {
  const validCompaniesIds = companiesIds?.filter(
    (id) => id && !isNaN(Number(id))
  );

  return useQuery<CompanyNumbersByCompany[]>({
    queryKey: ["company-numbers-by-companies", validCompaniesIds],
    enabled: !!validCompaniesIds && validCompaniesIds.length > 0,
    queryFn: async () => {
      const { data } = await gatewayPhone.get("/company-numbers/by-companies", {
        params: { companiesIds: validCompaniesIds?.join(",") },
      });
      return data;
    },
    retry: false,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
};